import Axios from '../axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { deserialize, serialize } from '../utility/serialization'
import { handleAPIError } from '../utility/actionHelper'

// THUNKS

export const updateEnrollment = createAsyncThunk(
  'enrollment/updateEnrollment',
  async ({ enrollmentData, coachMessage }, { rejectWithValue }) => {
    try {
      const { data } = await requestUpdateEnrollment(enrollmentData, coachMessage)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const deleteEnrollment = createAsyncThunk(
  'enrollment/deleteEnrollment',
  async ({ enrollmentId, refund, coachMessage, notifyViaEmail }, { rejectWithValue }) => {
    try {
      const { data } = await requestDeleteEnrollment(enrollmentId, refund, coachMessage, notifyViaEmail)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, rejectWithValue)
    }
  }
)

export const addEnrollmentManually = createAsyncThunk(
  'enrollment/addEnrollmentManually',
  async ({ user, program, message }, { rejectWithValue }) => {
    try {
      const enrollment = { userId: user.id, courseId: program.id }
      const { data } = await requestPostEnrollment(enrollment, message)

      return deserialize(data)
    } catch (error) {
      return handleAPIError(error, (err) => {
        const rejected = rejectWithValue(err)
        rejected.payload.userId = user.id

        return rejected
      })
    }
  }
)

// API CALLS

const requestPostEnrollment = (enrollmentData, message) => {
  const requestUrl = '/api/v1/enrollments'
  const params = {
    ...enrollmentData,
    coachMessage: message,
  }

  return Axios.post(requestUrl, serialize(params))
}

function requestUpdateEnrollment(enrollment, coachMessage = '') {
  const requestUrl = `/api/v1/enrollments/${enrollment.id}`

  return Axios.patch(requestUrl, { ...serialize(enrollment), coach_message: coachMessage })
}

function requestDeleteEnrollment(enrollmentId, refund, coachMessage = '', notifyViaEmail = false) {
  const requestUrl = `/api/v1/enrollments/${enrollmentId}`

  return Axios.delete(requestUrl, { params: { refund, coach_message: coachMessage, send_email: notifyViaEmail } })
}
